import { render, staticRenderFns } from "./iDelModel.vue?vue&type=template&id=0b365a18&lang=pug"
import script from "./iDelModel.vue?vue&type=script&lang=js"
export * from "./iDelModel.vue?vue&type=script&lang=js"
import style0 from "./iDelModel.vue?vue&type=style&index=0&id=0b365a18&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports